import { IMedia } from '../../../types/identicalOffers';
import { IMediaView } from '../../../types/identicalOffersView';

export function formatMedia({ photoUrl, ...media }: IMedia): IMediaView {
  return {
    ...media,
    photoUrl: photoUrl || null,
  };
}
